import {MesswertMeteogroupRbb} from '../messwerte/messwert-meteogroup-rbb';

export class FreizeitWetter {
  messwertMeteogroupRbb: MesswertMeteogroupRbb;

}
